module.exports = __webpack_public_path__ + "static/media/md-arrow-dropdown.b21e90ec.svg";